// Checklist - SLIDES (home)


page.checklist.slides = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    loadedSlide: 0,
    firstLoad: 0,
    resized: false,
    tween1: null,
    tween2: null,
    check: function(){
        this.reset();

        if(page.v.firstLoad) page.checklist.slides.first();

        if($('.section-slide').length > 2){
            this.enabled = true;
            log.page("CHECK: Homepage detected (slider)", 2);

            if(!page.three.v.models.loaded){
                this.needsLoad = true;
                log.webgl("CHECK: Models not loaded.", 1);
                page.three.control.models.load();
            }
        }

    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){

        let obj = page.checklist.slides;
        page.three.v.isMain = true;
        $('.header-logo').removeClass('.scrolled');

        var v = page.checklist.slides.v;
        var f = page.checklist.slides.f;
        page.main.fr.altMenu.default();

        $(".section-slide").each(function(id, el){
            $(el).data("slide", id);
        });

        $(".header-logo a").addClass('scrollTop');

        /* if($(document).width() > 1005){*/

        let $pagePosControl = $('.page-nav--scroll');
        $pagePosControl
            .removeClass('is-active')
            .first().addClass('is-active');

        $.scrollify({
            section: '.section-slide',
            interstitialSection: '.footer',
            updateHash: false,
            before: function(i){
                let delay = false;

                let curSlide = $.scrollify.currentIndex();

                log.page(`SLIDE: ${curSlide}`);

                if(curSlide !== 3){
                    $('.page-nr--current').html(curSlide+1);
                }

                var particles = page.control.particles;

                if($.scrollify.currentIndex() !== 3) {
                    $pagePosControl.removeClass('is-active');
                    $('.page-nav--scroll[data-section="' + ($.scrollify.currentIndex()) + '"]').addClass('is-active');
                }

                var oldActive = $(".fixed-slide.active");
                var oi = oldActive.attr("data-slide");

                if(oi == undefined) oi = 0;
                var df = i-oi > 0;

                if(i!=3 && !(oi==2 && i==2)){
                    //console.log("CHANGING " + i + " : " + oi);
                    particles.speedTo(12, 500);
                    particles.fadeTo(1, 500);
                    if(!df) particles.speedTo(-12, 500);

                    var target = oldActive.find("h2 span");
                    if(target.length == 0){
                        target = oldActive.find("h1 span");
                    }
                     TweenMax.killTweensOf(target);
                    target = oldActive.find(".fp_animate");
                     TweenMax.killTweensOf(target);

                    oldActive.removeClass('active');

                    let newActive = $('[data-slide='+i+']');
                    newActive.addClass('active');

                    target = newActive.find(".fp_animate");

                    if(page.checklist.slides.resized){
                        df = true;
                    }

                    let tween1 = TweenMax.fromTo(oldActive, df?0.5:1,
                        {autoAlpha:1, scale:1},
                        {autoAlpha: 0, scale: df?4:0.25, ease:df?Power1.easeIn:Power1.easeOut, force3D:true }
                    );


                    let tween2 = TweenMax.fromTo(newActive, 1.5,
                        {autoAlpha:0, scale: 1},
                        {autoAlpha: 1, ease:Power3.easeOut, delay: 0.5, force3D:true}
                    );


                     target = newActive.find(".fp_animate");

                    let tween3 = TweenMax.staggerFromTo(target, 1,
                        {autoAlpha:0, y:50},
                        {autoAlpha:1, y:0, ease:Power3.easeOut, stagger: 0.12, delay: 0.5}
                    );


                    page.checklist.slides.resized = false;

                    setTimeout(function () {
                        particles.fadeTo(0, 800);
                        particles.speedTo(0, 2000);
                    }, 400);
                }

            },
            afterRender: function(){
                page.main.fr.stupidMenu.showMenu.play();

                $pagePosControl.first().addClass('is-active');

                $.each($pagePosControl, function () {
                    $(this).css('height', $('.slider-rails').height() / $('.fixed-slide').length);
                });

               /* $.each($('.fixed-slide'),function(){
                    let item = $(this);
                    console.log(item);
                    if(!item.hasClass('active')){
                        TweenMax.set(item,{autoAlpha: 0, scale:1})
                    }else{
                        TweenMax.set(item,{autoAlpha: 1, scale:1})
                    }

                })*/

            },

            after: function(){

            }
        });

        let newActive = $(`[data-slide=0]`);
        newActive.addClass('active');
        obj.tween1 = TweenMax.fromTo(newActive, 1.5,
            {autoAlpha:0, scale: 1},
            {autoAlpha: 1, ease:Power3.easeOut, delay: 0.5, force3D:true}
        );
        var target = newActive.find(".fp_animate");

        obj.tween2 = TweenMax.staggerFromTo(target, 1,
            {autoAlpha:0, y:50},
            {autoAlpha:1, y:0, ease:Power1.easeOut, stagger: 0.2, delay: 0.5}
        );




        $pagePosControl.click(function (e) {
            e.preventDefault();
            $pagePosControl.removeClass('is-active');
            $(this).addClass('is-active');
            $.scrollify.move($(this).data('section'));
        });



        /*}*/

        if(isNaN(page.v.scroll.p_now)){
            page.v.scroll.p_now = 0;
        }

        page.control.bg.fadeColor(page.v.scroll.p_now, 1000);

        page.control.models.godrays.alpha = 1;
        page.control.models.banga.alpha = 0.12;
        page.control.models.bangaLand.alpha = 1;
        page.control.models.clouds.alpha = 0; // CHANGED
        page.control.models.land.alpha = 1;
        page.control.models.tree.alpha = 1;

        page.control.models.fadeTo(1, 1500);

        $('.header-logo').removeClass('scrolled');

        page.main.v.marketSticky.play();
        page.main.fr.stupidMenu.burgerStatus = false;
        //if(page.main.fr.stupidMenu.showBurger.duration() > 0)

        this.resize();
    },
    first: function(){

    },
    unload: function(){
        page.three.v.isMain = false;
        var v = page.checklist.slides.v;
        var f = page.checklist.slides.f;
        page.control.models.fadeTo(0, 1000);
        page.checklist.slides.firstLoad = 0;
        $(".header-logo a").removeClass('scrollTop');

        $('.page-nav--scroll').off();
        $.scrollify.disable();
        $.scrollify.destroy();

        $('.page-nav-fixed, .page-nr-fixed').removeClass('is-active');

        /* v.$sliderNav.removeClass('is-active');
         v.$pageNr.removeClass('is-active');*/
        page.main.fr.stupidMenu.burgerStatus = true;

        var oldActive = $(".fixed-slide.active");
        var target = oldActive.find("h2 span");
        if(target.length == 0){
            target = oldActive.find("h1 span");
        }

        TweenMax.killTweensOf(target);
        target = oldActive.find(".fp_animate");
        TweenMax.killTweensOf(target);

        oldActive.removeClass('active');
        TweenMax.fromTo(oldActive, 0.5, {autoAlpha:1, scale:1}, {autoAlpha: 0, scale: 4, ease:Power1.easeIn, force3D:true});
        page.checklist.slides.resized = false;
        this.reset();
    },
    fadein: function(){

    },
    fadeout: function(){

    },
    calc: function(){
        var wgl = page.three;
        var scroll = page.v.scroll;
        var time = page.v.time;

        if(page.checklist.slides.v.scrolled) page.control.bg.setColor(scroll.p_smooth);

        wgl.pTanMat.uniforms.uFarClose.value = scroll.p_smooth;
        wgl.tMat.uniforms.uFarClose.value = scroll.p_smooth;
        wgl.lMat.uniforms.uFarClose.value = scroll.p_smooth;

        if(scroll.p_now < 0.4){
            page.control.models.godrays.alpha = (1 - scroll.p_now*2.5) * page.config.godRayAlpha;
            wgl.godRays.uniforms["uOffset"].value.y = 0.6 + scroll.p_now * 0.5;
        }else{
            page.control.models.godrays.alpha = 0;
        }
        if(scroll.p_now > 0.6 && window.innerWidth > 1024){
            page.control.models.clouds.alpha = page.v.quality.clouds?(scroll.p_now-0.6)*2.5:0;
            //page.control.models.clouds.alpha = 0; // changed
        }else{
            page.control.models.clouds.alpha = 0;
        }

        if(scroll.p_now > 0.4 && scroll.smooth < 0.75){
            wgl.fxaaPass.enabled = false;
        }else{
            wgl.fxaaPass.enabled = true;
        }

        var isOne = $.scrollify.currentIndex() == 1;


        if(scroll.p_smooth <= 0.5){

            var s = scroll.p_now * 2;
            page.control.models.bangaLand.alpha = Math.max((isOne?scroll.p_smooth:scroll.p_now)-0.4,0)*10;

        }else{
            var s = 1 - (scroll.p_now-0.5) * 2;

            page.control.models.bangaLand.alpha = Math.max((1 - (isOne?scroll.p_smooth:scroll.p_now))-0.4,0)*10;
        }

        if(scroll.p_now <= 0.5){
            page.control.models.land.alpha = 1 - (!isOne?scroll.p_smooth:scroll.p_now)*2;
            wgl.lMat.uniforms.uColor.value = new THREE.Color(0.105, 0.356, 0.392);
            wgl.lMat.uniforms.uColor2.value = new THREE.Color(0.129, 0.313, 0.419);
        }else{
            page.control.models.land.alpha = (!isOne?scroll.p_smooth:scroll.p_now)*2 - 1;
            wgl.lMat.uniforms.uColor.value = new THREE.Color(0.062, 0.825, 0.462);
            wgl.lMat.uniforms.uColor2.value = new THREE.Color(0.074, 0.662, 0.454);//0.086, 0.588, 0.447
        }

        if(page.control.models.land.alpha < 0.01) page.control.models.land.alpha = 0;

        if(scroll.p_smooth > 0.75){
            page.control.models.tree.alpha = 1;
        }else{
            page.control.models.tree.alpha = 0;
        }
    },
    resize: function() {
        var wgl = page.three;
        var v = page.checklist.slides.v;
        var f = page.checklist.slides.f;

        var pos = THREE.Math.smoothstep(wgl.camera.aspect, 0.5, 2);

        wgl.banga.position.x = -2 - 1.5 * (1 - pos);
        wgl.bangaLand.position.x = -2 - 1.5 * (1 - pos);
        wgl.land.position.x = (pos) - 0.7333 - 0.1;
        wgl.tree.position.x = pos - 1.1;

        let $pagePosControl = $('.page-nav--scroll');
        let $pageControler = $('.page-nav-fixed');
        // let $pageNr = $('.page-nr-fixed');
        let $market = $('.sticky-market--contain');
        if($(document).width() < 1005){
            $.scrollify.disable();
            $pageControler.removeClass('is-active');
            //   $pageNr.removeClass('is-active');
            // $('.fixed-slide').removeClass('active');
        }else{

            if($.scrollify.isDisabled()){
                page.checklist.slides.resized = true;
                $.scrollify.enable();
                $.scrollify.move(0);
            }

            $pageControler.addClass('is-active');
            //  $pageNr.addClass('is-active');
            $market.css({height: 'auto'});
        }

        $.each($pagePosControl, function () {

            $(this).css('height', $('.slider-rails').height() / $('.fixed-slide').length);
        });

        //  $.scrollify.update();
        //  $.scrollify.move(0);
    },
    scroll: function(){
        page.checklist.slides.v.scrolled = true;

    },
    v:{
        scrolled:false,
        srolifyOptions: {
            section: ".section-slide",
            interstitialSection: '.footer-default',
            updateHash: false,
            before: function (i) {

                var v = page.checklist.slides.v;
                var particles = page.control.particles;
                var curSlide = $.scrollify.currentIndex();
                if (curSlide < v.totalSlides) {
                    v.$currSectionIndex.html(curSlide + 1);
                }

                if(curSlide == 2){
                    $('.header-nav').addClass('alt');
                }else{
                    $('.header-nav').removeClass('alt');
                }

                if (typeof v.$navRailSections[$.scrollify.currentIndex()] !== 'undefined') {
                    v.$navRailSections.removeClass('is-active');
                    $(v.$navRailSections[$.scrollify.currentIndex()]).addClass('is-active');

                    var oldActive = $(".fixed-slide.active");
                    var oi = oldActive.attr("data-slide");
                    if(oi == undefined) oi = 0;
                    var df = i-oi > 0;

                    if(i!=3 && !(oi==2 && i==2)){
                        //console.log("CHANGING " + i + " : " + oi);
                        particles.speedTo(12, 500);
                        particles.fadeTo(1, 500);
                        if(!df) particles.speedTo(-12, 500);;

                        var target = oldActive.find("h2 span");
                        if(target.length == 0){
                            target = oldActive.find("h1 span");
                        }
                        TweenMax.killTweensOf(target);
                        target = oldActive.find(".fp_animate");
                        TweenMax.killTweensOf(target);

                        oldActive.removeClass('active');
                        TweenMax.fromTo(oldActive, df?0.5:1, {autoAlpha:1, scale:1}, {autoAlpha: 0, scale: df?4:0.25, ease:df?Power1.easeIn:Power1.easeOut, force3D:true});
                        var newActive = $(`[data-slide=${i}]`);
                        newActive.addClass('active');

                        TweenMax.fromTo(newActive, 1.5, {autoAlpha:0, scale: 1}, {autoAlpha: 1, ease:Power3.easeOut, delay: 0.5, force3D:true});
                        var target = newActive.find(".fp_animate");
                        TweenMax.staggerFromTo(target, 1, {autoAlpha:0, y:50}, {autoAlpha:1, y:0, ease:Power3.easeOut, stagger: 0.12, delay: 0.5});

                        setTimeout(function () {
                            particles.fadeTo(0, 800);
                            particles.speedTo(0, 2000);
                        }, 400);
                    }

                    if (!v.$pageNr.hasClass('is-active')) {

                        setTimeout(function () {
                            v.$pageNr.addClass('is-active');
                            v.$sliderNav.addClass('is-active');
                        }, 340);
                    }
                } else {
                    v.$pageNr.removeClass('is-active');
                    v.$sliderNav.removeClass('is-active');
                    $(`[data-slide=${i}]`).addClass('active');

                }

            },
            afterResize: function () {
                var f = page.checklist.slides.f;
                //  $.scrollify.instantMove("#1");
                //$.scrollify.update();
                f.setSliderNav();
            },
            afterRender: function () {
                var v = page.checklist.slides.v;
                var f = page.checklist.slides.f;
                v.$sliderNav.addClass('is-active');
                v.$pageNr.addClass('is-active');
                f.setSliderNav();
                f.pageNavScroll();

                page.checklist.slides.loadedSlide = $.scrollify.currentIndex();
                page.checklist.slides.f.revealSlide();
            },
            after:function() {

            }
        }
    },
    f:{

    }
}
